import type { GalleryImageWithTitle } from 'Components/Gallery/MainGallery/MainGallery';
import type { PageSection } from 'Types/pageSection';

import { SECTIONS } from './VehicleDetailsRedesign.const';
import type { GetSectionsParams } from './VehicleDetailsRedesign.types';

export const hasGalleryImagesByKind = (images: GalleryImageWithTitle[], kinds: string[]): boolean =>
	images.some((image) => kinds.includes(image.kind));

export const getSections = ({
	includeAdditionalInfo,
	includeEarlyDocuments,
	includeExLease,
	includeMobilize,
	includeMobilizeDamage,
	includeRelistDetails,
	includeSummary,
	includeTraderDealerInfo,
}: GetSectionsParams): PageSection[] => {
	const conditionalSections = {
		additionalInfo: includeAdditionalInfo,
		conditionAndDamage: !includeMobilizeDamage,
		earlyDocuments: includeEarlyDocuments,
		exLease: includeExLease,
		mobilize: includeMobilize,
		mobilizeExteriorDamage: includeMobilizeDamage,
		mobilizeInteriorDamage: includeMobilizeDamage,
		mobilizeTyreDamage: includeMobilizeDamage,
		mobilizeWheelDamage: includeMobilizeDamage,
		relistDetails: includeRelistDetails,
		summary: includeSummary,
		tradeSellerDetails: includeTraderDealerInfo,
	};

	return SECTIONS.filter((section) => conditionalSections[section.id as keyof typeof conditionalSections] !== false);
};
